export { default as Automator } from './pages/index';
